var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vux-loader/src/script-loader.js!../vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7b5e996e\"}!../vux-loader/src/template-loader.js!../vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/swiper.vue
// module id = 566
// module chunks = 4